import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetPurchaseOrderDataByID,
  GetPurchaseOrderPartsByID,
  PrintPurchaseOrderApi,
} from "../../api";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/sale.css";
import { Card } from "react-bootstrap";
import "../../styles/viewCustomer.css";
import { Col, Container, Row } from "react-bootstrap";
import { Header } from "../../components";
import DateTimeField from "../../components/DateTimeField";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import CartListTable from "../../components/CartListTable";
import PosForm2 from "../../components/PosForm2";
import { showErrorToast } from "../../components/ToastMesg";

const ViewPurchaseOrder = () => {
  const navigate = useNavigate();
  let param = useParams();
  var po_id = param.po_id;
  const {
    currentColor,
    defaultImageMode,
    imageMode,
    setActiveProdMenu,
    setActiveProdMenuId,
  } = useStateContext();
  const [CartList, setCartList] = useState([]);
  const [store_id, setStore_id] = useState(0);
  const [oDatetime, setODatetime] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const [formData, setFormData] = useState({
    vendor: "select",
    vendor_invoice_no: "",
    po_revision: "",
    terms: "select",
    payment_status: "select",
    ship_method: "select",
    account: "select",
    tracking_no: "",
    r_to: "",
    r_street: "",
    r_city: "",
    r_state: "",
    r_zip: "",
    r_country: "",
    r_phone: "",
    s_to: "",
    s_street: "",
    s_city: "",
    s_state: "",
    s_zip: "",
    s_country: "",
    s_phone: "",
    amount_paid: 0,
    amount_pending: 0,
    sub_total: 0,
    total_items: 0,
    grand_total: 0,
    tax: 0,
    shipping: 0,
    note: "",
    status: "select",
  });

  const handleToggle = (value) => {
    if (value.part_id) {
      TimeoutUtility.resetTimeout();
      setActiveProdMenuId({ part_id: value.part_id, store_id: store_id });
      setActiveProdMenu(true);
    }
  };

  const handlePurchaseOrderClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate(`/Purchase/EditPurchaseOrder/${po_id}`);
  };

  const handlePrintOrderClick = async (e) => {
    const resp = await PrintPurchaseOrderApi(po_id);
    if (!resp) showErrorToast("Error!", "Print Record not found!");
  };

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (po_id) {
        setloading(true);
        trackPromise(
          Promise.all([
            GetPurchaseOrderDataByID(po_id),
            GetPurchaseOrderPartsByID(po_id),
          ])
            .then(([res, partRes]) => {
              setODatetime(res.data.order_date.slice(0, -1));
              setStore_id(res.data.store_id);
              let totalAmt = 0,
                totalItm = 0;
              if (partRes.data && partRes.data.length > 0) {
                const partList = partRes.data.map((item) => {
                  totalAmt +=
                    parseFloat(item.price) * parseFloat(item.quantity) || 0;
                  totalItm += parseFloat(item.quantity) || 0;
                  return {
                    part_id: item.non_part ? null : item.part_id,
                    name: `${item.part_number} - ${item.part_description}`,
                    part_number: item.part_number || "",
                    details: item.part_description || "",
                    unit_price: item.price || 0,
                    unit: item.unit || "-",
                    cost_price: item.cost_price || 0,
                    quantity: item.quantity || 0,
                    discount: 0,
                    total:
                      parseFloat(item.price) * parseFloat(item.quantity) || 0,
                    mfg_name: item.mfg_name,
                    mfg_pn: item.mfg_pn,
                    received_qty: item.quantity_received,
                    image: null,
                    expected_date: item.exp_rec_date
                      ? item.exp_rec_date.split("T")[0]
                      : "",
                    notes: item.item_note || "",
                  };
                });
                setCartList(() => [...partList]);
              }
              setFormData((prev) => ({
                ...prev,
                vendor: {
                  label: res.data.vendor,
                  value: res.data.vendor_id,
                },
                vendor_invoice_no: res.data.vendor_invoice_no,
                po_revision: res.data.po_revision,
                terms: res.data.term
                  ? { label: res.data.term, value: res.data.term_id }
                  : "select",
                payment_status: {
                  label: res.data.payment_status,
                  value: res.data.payment_status_id,
                },
                ship_method: {
                  label: res.data.ship_method,
                  value: res.data.ship_method_id,
                },
                account: {
                  label: res.data.acc_from,
                  value: res.data.acc_from_id,
                },
                tracking_no: res.data.tracking_no || "",
                r_to: res.data.remit_to || "",
                r_street: res.data.r_street || "",
                r_city: res.data.r_city || "",
                r_state: res.data.r_state || "",
                r_zip: res.data.r_zip || "",
                r_country: res.data.r_country || "",
                r_phone: res.data.r_phone || "",
                s_to: res.data.ship_to || "",
                s_street: res.data.s_street || "",
                s_city: res.data.s_city || "",
                s_state: res.data.s_state || "",
                s_zip: res.data.s_zip || "",
                s_country: res.data.s_country || "",
                s_phone: res.data.s_phone || "",
                amount_paid: res.data.amount_paid || 0,
                tax: res.data.tax || 0,
                shipping: res.data.shipment || 0,
                sub_total: totalAmt,
                grand_total: res.data.total_price,
                total_items: totalItm,
                note: res.data.po_note || "",
                status: {
                  label: res.data.po_status,
                  value: res.data.po_status_id,
                },
              }));
            })
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [po_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      {(loading || promiseInProgress) && (
        <div className="overlay-freeze">
          <LoadingIndicator />
        </div>
      )}
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={5} className="container-col">
            <Header title="VIEW PURCHASE ORDER" />
          </Col>
          <Col md={2} className="container-col">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              PO # {po_id}
            </label>
          </Col>
          <Col md={2} className="container-col">
            <DateTimeField
              label="DateTime:"
              name="order_date"
              value={oDatetime}
              placeholder="DateTime"
              now={false}
              disabled
              style={{ width: "178px" }}
            />
          </Col>
          <Col md={3} className="container-col text-center">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              Order Status: {formData.status.label}
            </label>
          </Col>
        </Row>
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={9} className="container-col">
            <div className="card-sale">
              <PosForm2
                formData={formData}
                currentColor={currentColor}
                type="purchase"
                viewOnly={true}
              />
              <Row className="table-container-sale03">
                <CartListTable
                  CartList={CartList}
                  imagePerm={defaultImageMode && imageMode}
                  type="purchase"
                  handleToggle={handleToggle}
                  viewOnly={true}
                  loading={promiseInProgress || loading}
                />
              </Row>
            </div>
          </Col>
          <Col md={3} className="container-col">
            <div className="card-sale">
              <Row xs={1} sm={1} className="justify-content-center p-0">
                <Col md={6} className="container-col left-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handlePurchaseOrderClick}
                  >
                    <div className="action-btn">EDIT</div>
                  </Card>
                </Col>
                <Col md={6} className="container-col right-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handlePrintOrderClick}
                  >
                    <div className="action-btn">PRINT</div>
                  </Card>
                </Col>
              </Row>
              <Row xs={1} sm={1} className="justify-content-center pl-3 pr-3">
                <Col md={6} className="container-col right-table-field">
                  <label>PO Rev Letter:</label>
                  <input
                    name="po_revision"
                    placeholder="PO Rev Letter"
                    value={formData.po_revision}
                    disabled
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Payment Status:</label>
                  <input
                    name="payment_status"
                    value={formData.payment_status.label || `-`}
                    placeholder="Select Payment Status"
                    disabled
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Ship Method:</label>
                  <input
                    name="ship_method"
                    value={formData.ship_method.label || `-`}
                    placeholder="Select Ship Method"
                    disabled
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Tracking No:</label>
                  <input
                    name="tracking_no"
                    value={formData.tracking_no}
                    disabled
                    placeholder="Tracking No"
                    className="input"
                  />
                </Col>
                <Col md={12} className="container-col right-table-field">
                  <label>Order Notes:</label>
                  <textarea
                    placeholder="Order Notes"
                    name="note"
                    value={formData.note}
                    disabled
                    className="textarea"
                  />
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center mt-3 pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Sub Total:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.sub_total)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Tax:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {`${formData.tax}%`}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Shipping:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.shipping)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Amount Paid:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.amount_paid)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Paid From:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formData.account.label || `-`}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Grand Total:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.grand_total)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Total Items:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formData.total_items || 0}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ViewPurchaseOrder;
